export interface RGPDState {
    shareEmailConsent: boolean | null;
    termsAndConditionsConsent: boolean | null;
}

const defaultState: RGPDState = {
    termsAndConditionsConsent: null,
    shareEmailConsent: null
};

export default defaultState;
